import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var CountryTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CountryTransformer, _BaseTransformer);
  var _super = _createSuper(CountryTransformer);
  function CountryTransformer() {
    _classCallCheck(this, CountryTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CountryTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        countryCode: data.country_code,
        countryName: data.country_name,
        label: data.country_name_tr,
        value: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return CountryTransformer;
}(BaseTransformer);